import { fetchWithTimeout } from '../helpers/utils';
export async function getIpAddress() {
    if (window.UNTUCKitConfig.ipAddressServerUrl) {
        try {
            const res = await fetchWithTimeout(window.UNTUCKitConfig.ipAddressServerUrl, {
                method: "get",
                mode: "cors"
            });
            const json = await res.json();
            return json.ip;
        }
        catch (e) {
            console.error("unable to fetch ip address", e.message || e);
            return null;
        }
    }
    else {
        return null;
    }
}
